<template>
  <div class="login">
    <div class="login-box">
      <!-- S 登录模式切换 -->
      <div class="tabs">
        <div
          :class="{ active: active == 2 }"
          class="tabs-item"
          @click="active = 2"
        >
          短信登录
        </div>
        <div
          :class="{ active: active == 1 }"
          class="tabs-item"
          @click="active = 1"
        >
          密码登录
        </div>
      </div>
      <!-- E 登录模式切换 -->

      <!-- S 登录表单 -->
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-form-item prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号码"
            prefix-icon="el-icon-mobile"
          />
        </el-form-item>
        <el-form-item v-if="active===2" prop="code">
          <el-input
            v-model="form.code"
            placeholder="验证码"
            prefix-icon="el-icon-chat-dot-square"
            maxlength="6"
          >
            <div slot="suffix" class="padding-lr-sm code-btn">
              <el-button
                :disabled="codeTime !== 60"
                type="text"
                @click="toGetCode"
              >
                {{ codeTime === 60 ? "获取验证码" : `${codeTime}s后重试` }}
              </el-button>
            </div>
          </el-input>
        </el-form-item>
        <el-form-item v-if="active===1" prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="isLoading"
            type="primary"
            class="width-full"
            @click="handleSubmit"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <!-- E 登录表单 -->

      <!-- S 其他操作 -->
      <div class="operate">
        <el-link type="primary" @click="selectRoleShow = true"> 注册账号</el-link>
        <el-link type="primary" @click="findAccountShow = true"> 账号找回</el-link>
        <el-link v-show="active == 1" type="primary" @click="$router.replace({ path: '/assist/forget' })">忘记密码？</el-link>
      </div>
      <!-- E 其他操作 -->

      <!-- S 账号找回 -->
      <findAccountDialog :visible.sync="findAccountShow" />
      <!-- E 账号找回 -->

      <!-- S 验证码 -->
      <captcha
        :dialog-show="showCaptcha"
        @success="toLogin"
        @toClose="showCaptcha = false"
      />
      <!-- E 验证码 -->

      <!-- S 注册账号 -->
      <selectRoleDialog
        :select-role-show="selectRoleShow"
        @close="selectRoleShow = false"
        @changeRole="changeRole"
      />
      <!-- E 注册账号 -->
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { rulesRequired, rulesPhone } from '@/assets/js/validate'

import findAccountDialog from './findAccountDialog.vue'
import selectRoleDialog from './selectRoleDialog.vue'
import captcha from '@/model/captcha'
export default {
  components: {
    findAccountDialog, selectRoleDialog, captcha
  },
  data() {
    return {
      active: 1, // 1:密码 2:短信
      codeTime: 60,
      form: {},

      showCaptcha: false,
      findAccountShow: false,
      selectRoleShow: false,
      role: '0', // 注册角色选择 0普通企业1工作站

      rules: {
        phone: [rulesRequired('请输入手机号码', 'blur'), rulesPhone('请输入正确的手机号码', 'blur')],
        code: [rulesRequired('请输入验证码', 'blur')],
        password: [rulesRequired('请输入密码', 'blur')]
      },
      isLoading: false
    }
  },
  watch: {
    active() {
      this.$refs['form'].clearValidate()
    }
  },
  created() {
    this.redirect = this.$route.query['redirect']
  },
  methods: {
    ...mapMutations(['setToken', 'setUserInfo', 'setLogoUrl']),
    timeCountDown() {
      if (this.codeTime === 0) {
        this.codeTime = 60
        return
      }
      setTimeout(() => {
        this.codeTime--
        this.timeCountDown()
      }, 1000)
    },
    toGetCode() {
      this.$refs['form'].validateField('phone', (errorMsg) => {
        if (!errorMsg) {
          this.timeCountDown()
          this.$api.getCode({ phone: this.form.phone, purpose: 2 }, () => {})
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.showCaptcha = true
        }
      })
    },
    toLogin() {
      this.showCaptcha = false
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isLoading = true
          if (this.active === 1) {
            this.pwdLogin()
          } else {
            this.codeLogin()
          }
        }
      })
    },
    pwdLogin() {
      this.$api.login(
        this.form,
        (res) => {
          let token = res.token
          this.setToken(token)
          this.toRedirect(this.redirect)
        },
        () => {
          this.isLoading = false
        }
      )
    },
    codeLogin() {
      this.$api.loginBySmsCode(
        {
          ...this.form,
          purpose: 2
        },
        (res) => {
          let token = res.token
          this.setToken(token)
          this.toRedirect(this.redirect)
        },
        () => {
          this.isLoading = false
        }
      )
    },
    toRedirect(redirect) {
      this.$api.getUserInfo((res) => {
        this.setUserInfo(res)
        this.setLogoUrl(res.logo)
        redirect = redirect || ['/jobManage', '/subAccountManage', '/enterpriseManage'][res['type']]
        this.$router.replace({ path: redirect }).catch(() => {})
      })
    },
    changeRole(role) {
      this.$router.replace({
        path: '/assist/register',
        query: {
          type: role
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  box-sizing: content-box;
  margin-left: 10px;
  width: 300px;
  padding: 10px 65px;
  height: 420px;
  background: #fff;
  box-shadow: 0 0 10px rgba(154, 154, 154, 0.3);
  border-radius: 5px;
  position: relative;
  &-box {
    // position: relative;
    padding-top: 65px;
    .tabs {
      height: 35px;
      font-size: 0;
      color: #999;
      line-height: 32px;
      margin-bottom: 45px;
      &-item {
        display: inline-block;
        font-size: 20px;
        margin-right: 50px;
        cursor: pointer;
        border-bottom: 3px solid transparent;

        &.active {
          color: #333;
          border-bottom-color: #03a9f4;
        }

        &:nth-child(n + 2) {
          margin-right: 0;
        }
      }
    }

    .operate{
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assist/login/common.vue